import {Component, OnInit, ViewChild} from '@angular/core';
import {AlertController,  LoadingController, NavController, NavParams} from 'ionic-angular';
import {LoginPage} from "../login/login";
import {SmartanimationProvider} from "../../providers/smartanimation/smartanimation";
import {AbstractControl, FormBuilder, FormGroup, Validators} from "@angular/forms";
import {LoginServiceProvider} from "../../providers/authservice/loginService";
import {SignupSuccessPage} from "../signup-success/signup-success";

@Component({
  selector: 'page-resetpassword',
  templateUrl: 'resetpassword.html',
})
export class ResetpasswordPage implements OnInit{
  @ViewChild('resetAnimation')resetAnimation;
  resetForm:FormGroup;
  email:AbstractControl;
  constructor(

              public navCtrl: NavController,
              public navParams: NavParams,
              public animationService:SmartanimationProvider,
              public fb:FormBuilder,
              public authservice:LoginServiceProvider,
              public loadingCtrl:LoadingController,
              public alrtCtrl:AlertController
  )
  {

  }
  ngOnInit(){
    this.resetForm=this.fb.group({
       email:['',Validators.compose([Validators.required,Validators.email])]
     });
     this.email=this.resetForm.controls['email'];
  }

  resetPassword(resetForm:any){
    if(this.resetForm.valid){
      let loading = this.loadingCtrl.create({
        content:'Please wait ...',
      });
      loading.present();
      this.authservice.resetPassword(resetForm.email).then((response)=>{
        loading.dismiss().then(()=>{
          // console.log(response.toString());
        });
      }).catch((error)=>{
        loading.dismiss().then(()=>{
          console.log(error);
        })
      })
    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ResetpasswordPage');
  }
  goBack(){
    this.navCtrl.setRoot(LoginPage);
  }

  success(){
    this.navCtrl.push(SignupSuccessPage);
  }

  ionViewWillEnter()
  {
    this.animationService.smartAnimation().setType('fadeIn').show(this.resetAnimation.nativeElement);
  }

}



// WEBPACK FOOTER //
// ./src/pages/resetpassword/resetpassword.ts